(() => {
  const initCartTerms = () => {
    const root = document.querySelector('[data-cart-terms]');
    const checkbox = root?.querySelector('[data-cart-terms-checkbox]');
    const error = root?.querySelector('[data-cart-terms-error]');
    const checkout = document.querySelector('#checkout');
    const cartBlocks = root?.closest('.cart__blocks');
    const cartForm = document.querySelector('#cart');

    if (!root || !checkbox || !checkout || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const updateState = () => {
      const accepted = checkbox.checked;

      root.classList.toggle('is-checked', accepted);
      cartBlocks?.classList.toggle('is-terms-locked', !accepted);
      checkout.classList.toggle('is-terms-locked', !accepted);
      checkout.setAttribute('aria-disabled', String(!accepted));

      if (accepted) {
        root.classList.remove('has-error');
        error.hidden = true;
      }
    };

    const showError = () => {
      root.classList.add('has-error');
      error.hidden = false;
      checkbox.focus();
    };

    checkbox.addEventListener('change', updateState);

    // WINDOW-szintű capture: a mennyiségi-kedvezmény app (quantity-price-break.js)
    // SAJÁT click-handlert tesz a checkout-gombra, és aszinkron location.href-fel
    // navigál a checkoutra — a gombra tett preventDefault ezt nem állítja meg.
    // A capture fázis a window-nál kezdődik, így ez MINDEN más handler előtt fut,
    // és stopImmediatePropagation-nel az app handlere el sem indul.
    window.addEventListener(
      'click',
      (event) => {
        if (checkbox.checked) return;
        if (!event.target || !event.target.closest) return;
        // A gyorsfizetős (wallet) gombok zárt állapotban pointer-events: none-t
        // kapnak, így a kattintás a .cart__dynamic-checkout-buttons wrapperre
        // esik — arra is hibaüzenettel válaszolunk.
        if (!event.target.closest('#checkout, button[name="checkout"], .cart__checkout-button, .cart__dynamic-checkout-buttons, .additional-checkout-buttons')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();
        showError();
      },
      true
    );

    cartForm?.addEventListener(
      'submit',
      (event) => {
        if (checkbox.checked) return;
        event.preventDefault();
        showError();
      },
      true
    );

    updateState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartTerms);
  } else {
    initCartTerms();
  }
})();
